import { Categories } from "../components/categories/Categories";
 export const CategoriesPage = () => {
  return (
     <Categories/>
  )
}

